import InfoIcon from '@mui/icons-material/Info';
import { Box, styled, Tooltip } from '@/theme/index';

export const StyledBox = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  background: theme.palette.primary.contrastText,
  borderRadius: theme.spacing(1),
  display: 'flex',
  gap: theme.spacing(1),
  justifyContent: 'center',
  padding: theme.spacing(1),
  boxShadow: `0px 2px 5px 0px ${theme.palette.secondary.contrastText}`,
}));

export const StyledInfoIcon = styled(InfoIcon)(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
}));

export const StyledToolTip = styled(Tooltip)(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
  '&.MuiTooltip-arrow': {
    color: theme.palette.secondary.contrastText,
  },
  '.MuiTooltip-tooltip': {
    backgroundColor: theme.palette.secondary.contrastText,
    color: theme.palette.primary.contrastText,
  },
}));
